import { apiClient } from "@api/client";
import { request } from "@api/request";

import type {
  EventCatalog,
  TraceDetail,
  TracePage,
  TraceSummary,
} from "./types";

const TRACE_PAGE_SIZE = 25;

export const fetchTracePage = (
  cursor: string | undefined,
  search: string,
  status: TraceSummary["status"] | "",
  signal: AbortSignal,
): Promise<TracePage> =>
  request(() =>
    apiClient.GET("/event-traces", {
      params: {
        query: {
          cursor,
          limit: TRACE_PAGE_SIZE,
          search: search || undefined,
          status: status || undefined,
        },
      },
      signal,
    }),
  );

export const fetchTraceDetail = (
  eventUuid: string,
  signal: AbortSignal,
): Promise<TraceDetail> =>
  request(() =>
    apiClient.GET("/event-traces/{event_uuid}", {
      params: { path: { event_uuid: eventUuid } },
      signal,
    }),
  );

/** Wire: `policy_version=all` asks for every registered version; the response scope then has `policy_version: null`. */
export const ALL_POLICY_VERSIONS = "all";

export const fetchEventCatalog = (
  policyVersion: string | undefined,
  windowDays: number,
  signal: AbortSignal,
): Promise<EventCatalog> =>
  request(() =>
    apiClient.GET("/event-traces/catalog", {
      params: {
        query: { policy_version: policyVersion, window_days: windowDays },
      },
      signal,
    }),
  );
